import { useLinkProps } from '@react-navigation/native';
import { useCallback } from 'react';
import { isWeb, isWebView } from 'src/utils/platform';
export default function useNavPressableLink({ to, onPress, disabled, }) {
    const { href, onPress: linkOnPress, accessibilityRole, } = useLinkProps({ to });
    const mergedOnPress = useCallback((e) => {
        onPress?.(e);
        linkOnPress(e);
    }, [linkOnPress, onPress]);
    const useWebHref = isWeb && !isWebView && !disabled;
    return {
        onPress: mergedOnPress,
        href: useWebHref ? href : undefined,
        accessibilityRole: useWebHref ? accessibilityRole : undefined,
    };
}
